"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_BASE_1 = require("../../THEME_BASE");
var opacify_1 = __importDefault(require("../../utils/opacify"));
var utils_1 = require("../../utils");
var buttonColors = function (colorScheme, colors, primaryShade) {
    var _a;
    var customColors = {
        gray: (_a = {},
            _a[THEME_BASE_1.COLOR_SCHEME_LIGHT] = (0, opacify_1.default)(colors.gray[2], 0.4),
            _a[THEME_BASE_1.COLOR_SCHEME_DARK] = colors.gray[3],
            _a),
    };
    return Object.fromEntries(THEME_BASE_1.VARIANT_NAMES.map(function (variantName) {
        var _a, _b;
        var background = (_b = (_a = customColors[variantName]) === null || _a === void 0 ? void 0 : _a[colorScheme]) !== null && _b !== void 0 ? _b : colors[variantName][primaryShade];
        return [
            variantName,
            { background: background, color: (0, utils_1.contrastingColor)(background) },
        ];
    }));
};
exports.default = buttonColors;
